var _clipPath, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoDerbyMuseums = function SvgLogoDerbyMuseums(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    viewBox: "0 0 579 431"
  }, props), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.005)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.005 0h578.096v430.938H.005z",
    style: {
      fill: "none"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.005 0h578.096v430.938H.005z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-10.834c-.264 2.751-1.409 5.349-3.245 7.311C-5.461-1.163-8.619 0-12.941 0h12.87v-8.898q0-1.023.071-1.936",
    style: {
      fill: "#009fe3",
      fillRule: "nonzero"
    },
    transform: "matrix(12.65018 0 0 12.65018 275.81 304.204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-8.063C2.07-5.848 3.232-2.797 3.232.325q-.001.549-.048 1.091c.285-3.372 1.339-5.684 3.44-7.663a11.6 11.6 0 0 1 1.974-1.477 12.7 12.7 0 0 0-6.455-1.755c-1.09 0-2.169.144-3.208.416q.55.454 1.065 1",
    style: {
      fill: "#009fe3",
      fillRule: "nonzero"
    },
    transform: "matrix(12.65018 0 0 12.65018 235.673 147.564)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-13.291c1.443-1.348 3.24-2.308 5.181-2.816-2.157-1.779-4.789-2.522-8.667-2.522h-8.897V5.338h8.86v-8.897c0-4.539 1.017-7.372 3.523-9.732",
    style: {
      fill: "#ffed00",
      fillRule: "nonzero"
    },
    transform: "matrix(12.65018 0 0 12.65018 156.66 236.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 14.399c1.836-1.962 2.981-4.56 3.245-7.311l.011-.133q.047-.541.048-1.09c0-3.123-1.161-6.174-3.231-8.388a12 12 0 0 0-1.066-1c-1.94.507-3.738 1.467-5.18 2.815-2.506 2.36-3.523 5.193-3.523 9.732v8.898c4.322 0 7.481-1.163 9.696-3.523",
    style: {
      fill: "#009641",
      fillRule: "nonzero"
    },
    transform: "matrix(12.65018 0 0 12.65018 234.755 77.487)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-15.252c-2.251-2.106-5.338-3.305-8.534-3.305-2.276 0-4.511.62-6.415 1.756.748.441 1.447.958 2.079 1.549 2.36 2.215 3.523 5.375 3.523 9.696v8.861h12.87v-8.861c0-4.321-1.162-7.481-3.523-9.696",
    style: {
      fill: "#e6007d",
      fillRule: "nonzero"
    },
    transform: "matrix(12.65018 0 0 12.65018 533.543 262.39)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-17.008a12 12 0 0 0-2.079-1.549c-.708.423-1.373.915-1.973 1.477-2.102 1.979-3.156 4.291-3.441 7.663l-.011.133a25 25 0 0 0-.071 1.936v8.897H3.523v-8.861c0-4.321-1.163-7.481-3.523-9.696",
    style: {
      fill: "#312783",
      fillRule: "nonzero"
    },
    transform: "matrix(12.65018 0 0 12.65018 370.738 284.604)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-1.763c-.172-.127-.421-.191-.774-.191h-.49V.191h.49C-.039.191.372-.196.372-.886c0-.368-.142-.705-.372-.877M.593.26C.294.578-.132.735-.715.735H-1.91v-3.233h1.2c.612 0 .994.137 1.313.475.279.299.435.711.435 1.132C1.038-.46.877-.044.593.26",
    style: {
      fillRule: "nonzero"
    },
    transform: "matrix(12.65018 0 0 12.65018 60.481 379.354)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 3.233V0h1.969v.524H.617v.798h1.107v.525H.617v.862h1.416v.524z",
    style: {
      fillRule: "nonzero"
    },
    transform: "matrix(12.65018 0 0 12.65018 82.357 347.753)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-2.185h-.402v.891H0c.392 0 .563-.137.563-.46 0-.309-.161-.431-.563-.431M.646.524-.093-.769h-.309V.524h-.617v-3.233H.059c.47 0 .685.059.877.24q.264.244.264.7 0 .374-.176.608c-.123.156-.235.225-.505.299L1.323.524z",
    style: {
      fillRule: "nonzero"
    },
    transform: "matrix(12.65018 0 0 12.65018 130.25 382.028)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 .461h-.402v.891H0c.191 0 .279-.009.372-.058A.41.41 0 0 0 .593.917C.593.622.382.461 0 .461M0-.896h-.402v.833h.368C.313-.063.5-.21.5-.484c0-.26-.187-.412-.5-.412m.27 2.743h-1.318v-3.233h1.17c.422 0 .632.054.809.216a.8.8 0 0 1 .255.578.8.8 0 0 1-.187.509C.857.079.725.138.47.152c.49.01.799.328.799.833 0 .559-.353.862-.999.862",
    style: {
      fillRule: "nonzero"
    },
    transform: "matrix(12.65018 0 0 12.65018 168.046 365.283)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 .461v1.386h-.617V.461l-.985-1.847h.676l.647 1.264.681-1.264h.675z",
    style: {
      fillRule: "nonzero"
    },
    transform: "matrix(12.65018 0 0 12.65018 208.197 365.283)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 3.233V.862c-.024.167-.029.187-.122.46l-.74 1.911h-.554l-.675-1.876a3 3 0 0 1-.123-.514v2.39h-.558V0h.739l.862 2.307c.04.093.049.127.064.25a.7.7 0 0 1 .059-.25L-.152 0h.74v3.233z",
    style: {
      fillRule: "nonzero"
    },
    transform: "matrix(12.65018 0 0 12.65018 281.62 347.753)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 2.826c-.235.161-.509.235-.911.235-.407 0-.671-.068-.916-.235-.333-.23-.441-.5-.441-1.092V-.235h.612v2.003c0 .48.25.72.764.72.471 0 .72-.255.72-.72V-.235h.618v1.969c0 .592-.108.857-.446 1.092",
    style: {
      fillRule: "nonzero"
    },
    transform: "matrix(12.65018 0 0 12.65018 329.827 350.73)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-1.704q-.514-.229-.838-.23c-.289 0-.475.117-.475.299 0 .137.079.22.309.342q.742.396.97.622c.137.138.22.353.22.579 0 .577-.421.915-1.136.915-.098 0-.196-.009-.289-.019-.23-.035-.338-.069-.676-.226A6 6 0 0 1-2.126.48l.26-.568c.235.128.333.176.461.226.161.059.337.093.465.093.284 0 .47-.128.47-.323 0-.138-.074-.231-.284-.348l-.5-.285c-.573-.328-.75-.543-.75-.896a.87.87 0 0 1 .128-.451.9.9 0 0 1 .24-.239c.235-.162.436-.216.813-.216.216 0 .407.024.608.083.156.049.244.084.46.187z",
    style: {
      fillRule: "nonzero"
    },
    transform: "matrix(12.65018 0 0 12.65018 369.792 379.04)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 3.233V0h1.969v.524H.617v.798h1.107v.525H.617v.862h1.416v.524z",
    style: {
      fillRule: "nonzero"
    },
    transform: "matrix(12.65018 0 0 12.65018 381.875 347.753)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 2.826c-.235.161-.509.235-.911.235-.407 0-.671-.068-.916-.235-.333-.23-.441-.5-.441-1.092V-.235h.613v2.003c0 .48.25.72.763.72.471 0 .721-.255.721-.72V-.235h.617v1.969c0 .592-.108.857-.446 1.092",
    style: {
      fillRule: "nonzero"
    },
    transform: "matrix(12.65018 0 0 12.65018 444.516 350.73)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 3.233V.862c-.024.167-.029.187-.122.46l-.74 1.911h-.554l-.675-1.876a3 3 0 0 1-.123-.514v2.39h-.558V0h.739l.862 2.307c.04.093.049.127.064.25.02-.152.024-.171.059-.25L-.152 0h.74v3.233z",
    style: {
      fillRule: "nonzero"
    },
    transform: "matrix(12.65018 0 0 12.65018 497.307 347.753)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-1.704q-.514-.229-.838-.23c-.289 0-.475.117-.475.299 0 .137.079.22.309.342q.742.396.97.622c.137.138.22.353.22.579 0 .577-.421.915-1.136.915-.098 0-.196-.009-.289-.019-.23-.035-.339-.069-.676-.226A6 6 0 0 1-2.126.48l.26-.568c.235.128.333.176.46.226.162.059.338.093.466.093.284 0 .47-.128.47-.323 0-.138-.074-.231-.284-.348l-.5-.285c-.573-.328-.75-.543-.75-.896a.87.87 0 0 1 .128-.451.9.9 0 0 1 .24-.239c.235-.162.436-.216.813-.216.216 0 .407.024.607.083.157.049.245.084.461.187z",
    style: {
      fillRule: "nonzero"
    },
    transform: "matrix(12.65018 0 0 12.65018 540.496 379.04)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M578.105 426.344H.017v5.592h578.088z"
  })))));
};
export { SvgLogoDerbyMuseums as ReactComponent };
export default __webpack_public_path__ + "static/logo-derby-museums.438e1059.svg";